import CommonLink from 'common/components/entities/Button/link-new'
import { ButtonLinkTypeEnum } from 'common/enums/ButtonLinkEnum'
import { PageTypeEnum } from 'common/enums/PageTypeEnum'
import { ButtonInterface } from 'common/types/entities/button-interface'
import StyleWrapper from 'publisher/components/core/StyleWrapper'
import { usePage } from 'publisher/store'
import { getPageType } from 'publisher/store/page/pageSelectors'
import React from 'react'
import { useCalculateButtonStyles } from 'src/publisher/shared/hooks/use-calculate-button-styles'
import { useSelectedButtonColor } from 'src/publisher/shared/hooks/use-theme-color/use-selected-button-color'

const TEST_ID = 'open-url-button'

export interface OpenUrlButtonProps {
  entity: ButtonInterface
}

const OpenUrlButton = ({ entity }: OpenUrlButtonProps) => {
  const pageType = usePage(getPageType)

  const {
    calculatedBorder,
    calculatedPadding,
    calculatedFontSize,
    calculatedLineHeight,
    // calculatedTextAlign,
    // calculatedLetterSpacing,
    calculatedFontFamily,
    calculatedFontWeight,
    calculatedFontStyle,
  } = useCalculateButtonStyles({
    border: entity.border,
    mobileBorder: entity.mobileBorder,
    padding: entity.padding,
    mobilePadding: entity.mobilePadding,
    buttonType: entity.buttonType,
    fontSize: entity.textFontSize,
    mobileFontSize: entity.mobileTextFontSize,
    lineHeight: entity.lineHeight,
    mobileLineHeight: entity.mobileLineHeight,
    fontFamily: entity.textFontFamily,
    mobileFontFamily: entity.mobileTextFontFamily,
    fontWeight: entity.textFontWeight,
    mobileFontWeight: entity.mobileTextFontWeight,
    fontStyle: entity.textFontStyle,
    mobileFontStyle: entity.mobileTextFontStyle,
  })

  const {
    buttonTextColor,
    buttonBackgroundColor,
    hoveredButtonBackgroundColor,
  } = useSelectedButtonColor(entity.buttonType)

  let target: ButtonLinkTypeEnum | '_parent' =
    entity.linkTarget ?? ButtonLinkTypeEnum.openInSameWindow

  if (
    pageType === PageTypeEnum.Lecture &&
    target === ButtonLinkTypeEnum.openInSameWindow
  ) {
    target = '_parent'
  }

  return (
    <StyleWrapper
      flex
      flexColumn
      margin={entity.margin}
      mobileMargin={entity.mobileMargin}
      appearance={entity.appearance}
    >
      <CommonLink
        dataTestId={TEST_ID}
        /* @ts-ignore */
        href={entity.linkUrl}
        rel={entity.rel}
        target={target}
        iconClassNameBefore={entity.iconClassNameBefore}
        iconClassNameAfter={entity.iconClassNameAfter}
        text={entity.text}
        border={calculatedBorder.desktop}
        mobileBorder={calculatedBorder.mobile}
        subText={entity.subText}
        padding={calculatedPadding.desktop}
        mobilePadding={calculatedPadding.mobile}
        alignSelf={entity.alignSelf}
        mobileAlignSelf={entity.mobileAlignSelf}
        background={
          (entity.background ?? entity.backgroundColor) || buttonBackgroundColor
        }
        mobileBackground={
          (entity.mobileBackground ?? entity.mobileBackgroundColor) ||
          buttonBackgroundColor
        }
        attrId={entity.htmlAttrId}
        width={entity.width}
        mobileWidth={entity.mobileWidth}
        textColor={entity.textColor || buttonTextColor}
        subTextColor={entity.subTextColor}
        mobileTextColor={entity.mobileTextColor || buttonTextColor}
        mobileSubTextColor={entity.mobileSubTextColor}
        textFontSize={calculatedFontSize.desktop}
        mobileTextFontSize={calculatedFontSize.mobile}
        subTextFontSize={entity.subTextFontSize}
        mobileSubTextFontSize={entity.mobileSubTextFontSize}
        textFontFamily={calculatedFontFamily.desktop}
        textFontWeight={calculatedFontWeight.desktop}
        textFontStyle={calculatedFontStyle.desktop}
        lineHeight={calculatedLineHeight.desktop}
        subTextFontFamily={entity.subTextFontFamily}
        subTextFontWeight={entity.subTextFontWeight}
        subTextFontStyle={entity.subTextFontStyle}
        mobileTextFontFamily={calculatedFontFamily.mobile}
        mobileTextFontWeight={calculatedFontWeight.mobile}
        mobileTextFontStyle={calculatedFontStyle.mobile}
        mobileLineHeight={calculatedLineHeight.mobile}
        mobileSubTextFontFamily={entity.mobileSubTextFontFamily}
        mobileSubTextFontWeight={entity.mobileSubTextFontWeight}
        mobileSubTextFontStyle={entity.mobileSubTextFontStyle}
        boxShadow={entity.boxShadow}
        mobileBoxShadow={entity.mobileBoxShadow}
        hover={{
          ...entity.hover,
          backgroundColor:
            entity?.hover?.backgroundColor || hoveredButtonBackgroundColor,
        }}
        mobileHover={{
          ...entity.mobileHover,
          backgroundColor:
            entity?.mobileHover?.backgroundColor ||
            entity?.hover?.backgroundColor ||
            hoveredButtonBackgroundColor,
        }}
      />
    </StyleWrapper>
  )
}

export default OpenUrlButton
